import request from '@/utils/request'

/**
 * 保存进货订单
 * @param {Object} data 订单数据
 * @returns {Promise} 返回请求结果
 */
export function saveInoutOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/saveInoutOrder',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取供应商列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回请求结果
 */
export function listResourceSuppliers(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/resourceSupplier/listResourceSuppliers',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取商品列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回请求结果
 */
export function listProducts(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product/listProducts',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取商品分类
 * @returns {Promise} 返回请求结果
 */
export function listProductCategories() {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory/listProductCategories',
      method: 'get'
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}